import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"video-2, camera, movie, play"} maskId="square-filled-radius-0-stroke-1-IconVideo2"><path d="M17 19H2V5H17V19Z" fill="currentColor"/><path d="M22.9473 18.2246L18.3223 16.4678L18 16.3447V7.65527L18.3223 7.53223L22.9473 5.77539V18.2246Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVideo2;
